import { BankAccountType } from '__core/shared/model/global/BankAccountType.enum';
import { CertificateOfTitle } from '__core/shared/model/global/CertificateOfTitle.enum';
import { CreditCardType } from '__core/shared/model/global/CreditCardType.enum';
import { CreditRecordOption } from '__core/shared/model/global/CreditRecordOption.enum';
import { FrequencyOption } from '__core/shared/model/global/FrequencyOption.enum';
import { ImportantOption } from '__core/shared/model/global/ImportantOption.enum';
import { LevelOption } from '__core/shared/model/global/LevelOption.enum';
import { OwnershipType } from '__core/shared/model/global/OwnershipType.enum';
import { PaymentFrequency } from '__core/shared/model/global/PaymentFrequency.enum';
import { PersonalTitle } from '__core/shared/model/global/PersonalTitle.enum';
import { PropertyType } from '__core/shared/model/global/PropertyType.enum';
import { TransactionType } from '__core/shared/model/global/TransactionType.enum';
import { TypeOfCertificateOfTitle } from '__core/shared/model/global/TypeOfCertificateOfTitle.enum';
import { VehicleType } from '__core/shared/model/global/VehicleType.enum';
import { YesNoOption } from '__core/shared/model/global/YesNoOption.enum';
import { ZoningOption } from '__core/shared/model/global/ZoningOption.enum';

export default angular
  .module('st.Global', [])
  .factory('BankAccountType', () => BankAccountType)
  .factory('CertificateOfTitle', () => CertificateOfTitle)
  .factory('CreditCardType', () => CreditCardType)
  .factory('CreditRecordOption', () => CreditRecordOption)
  .factory('FrequencyOption', () => FrequencyOption)
  .factory('ImportantOption', () => ImportantOption)
  .factory('LevelOption', () => LevelOption)
  .factory('OwnershipType', () => OwnershipType)
  .factory('PaymentFrequency', () => PaymentFrequency)
  .factory('PersonalTitle', () => PersonalTitle)
  .factory('PropertyType', () => PropertyType)
  .factory('TransactionType', () => TransactionType)
  .factory('TypeOfCertificateOfTitle', () => TypeOfCertificateOfTitle)
  .factory('VehicleType', () => VehicleType)
  .factory('YesNoOption', () => YesNoOption)
  .factory('ZoningOption', () => ZoningOption)
  .constant('GLOBAL', {
    APPLICATION_NAME: 'Salestrekker',
    THEMES: [
      'st-lime',
      'st-lime-h100',
      'st-lime-h200',
      'st-lime-h300',
      'st-lime-h400',
      'st-lime-h500',
      'st-lime-h600',
      'st-lime-h700',
      'st-lime-h800',
      'st-lime-h900',
      'st-lime-ha100',
      'st-lime-ha200',
      'st-lime-ha400',
      'st-lime-ha700',
      'st-green',
      'st-green-h100',
      'st-green-h200',
      'st-green-h300',
      'st-green-h400',
      'st-green-h500',
      'st-green-h600',
      'st-green-h700',
      'st-green-h800',
      'st-green-h900',
      'st-green-ha100',
      'st-green-ha200',
      'st-green-ha400',
      'st-green-ha700',
      'st-amber',
      'st-amber-h100',
      'st-amber-h200',
      'st-amber-h300',
      'st-amber-h400',
      'st-amber-h500',
      'st-amber-h600',
      'st-amber-h700',
      'st-amber-h800',
      'st-amber-h900',
      'st-amber-ha100',
      'st-amber-ha200',
      'st-amber-ha400',
      'st-amber-ha700',
      'st-blue-grey',
      'st-blue-grey-h100',
      'st-blue-grey-h200',
      'st-blue-grey-h300',
      'st-blue-grey-h400',
      'st-blue-grey-h500',
      'st-blue-grey-h600',
      'st-blue-grey-h700',
      'st-blue-grey-h800',
      'st-blue-grey-h900',
      'st-blue-grey-ha100',
      'st-blue-grey-ha200',
      'st-blue-grey-ha400',
      'st-blue-grey-ha700',
      'st-red',
      'st-red-h100',
      'st-red-h200',
      'st-red-h300',
      'st-red-h400',
      'st-red-h500',
      'st-red-h600',
      'st-red-h700',
      'st-red-h800',
      'st-red-h900',
      'st-red-ha100',
      'st-red-ha200',
      'st-red-ha400',
      'st-red-ha700',
      'st-pink',
      'st-pink-h100',
      'st-pink-h200',
      'st-pink-h300',
      'st-pink-h400',
      'st-pink-h500',
      'st-pink-h600',
      'st-pink-h700',
      'st-pink-h800',
      'st-pink-h900',
      'st-pink-ha100',
      'st-pink-ha200',
      'st-pink-ha400',
      'st-pink-ha700',
      'st-purple',
      'st-purple-h100',
      'st-purple-h200',
      'st-purple-h300',
      'st-purple-h400',
      'st-purple-h500',
      'st-purple-h600',
      'st-purple-h700',
      'st-purple-h800',
      'st-purple-h900',
      'st-purple-ha100',
      'st-purple-ha200',
      'st-purple-ha400',
      'st-purple-ha700',
      'st-deep-purple',
      'st-deep-purple-h100',
      'st-deep-purple-h200',
      'st-deep-purple-h300',
      'st-deep-purple-h400',
      'st-deep-purple-h500',
      'st-deep-purple-h600',
      'st-deep-purple-h700',
      'st-deep-purple-h800',
      'st-deep-purple-h900',
      'st-deep-purple-ha100',
      'st-deep-purple-ha200',
      'st-deep-purple-ha400',
      'st-deep-purple-ha700',
      'st-indigo',
      'st-indigo-h100',
      'st-indigo-h200',
      'st-indigo-h300',
      'st-indigo-h400',
      'st-indigo-h500',
      'st-indigo-h600',
      'st-indigo-h700',
      'st-indigo-h800',
      'st-indigo-h900',
      'st-indigo-ha100',
      'st-indigo-ha200',
      'st-indigo-ha400',
      'st-indigo-ha700',
      'st-cyan',
      'st-cyan-h100',
      'st-cyan-h200',
      'st-cyan-h300',
      'st-cyan-h400',
      'st-cyan-h500',
      'st-cyan-h600',
      'st-cyan-h700',
      'st-cyan-h800',
      'st-cyan-h900',
      'st-cyan-ha100',
      'st-cyan-ha200',
      'st-cyan-ha400',
      'st-cyan-ha700',
      'st-teal',
      'st-teal-h100',
      'st-teal-h200',
      'st-teal-h300',
      'st-teal-h400',
      'st-teal-h500',
      'st-teal-h600',
      'st-teal-h700',
      'st-teal-h800',
      'st-teal-h900',
      'st-teal-ha100',
      'st-teal-ha200',
      'st-teal-ha400',
      'st-teal-ha700',
      'st-deep-orange',
      'st-deep-orange-h100',
      'st-deep-orange-h200',
      'st-deep-orange-h300',
      'st-deep-orange-h400',
      'st-deep-orange-h500',
      'st-deep-orange-h600',
      'st-deep-orange-h700',
      'st-deep-orange-h800',
      'st-deep-orange-h900',
      'st-deep-orange-ha100',
      'st-deep-orange-ha200',
      'st-deep-orange-ha400',
      'st-deep-orange-ha700',
      'st-brown',
      'st-brown-h100',
      'st-brown-h200',
      'st-brown-h300',
      'st-brown-h400',
      'st-brown-h500',
      'st-brown-h600',
      'st-brown-h700',
      'st-brown-h800',
      'st-brown-h900',
      'st-brown-ha100',
      'st-brown-ha200',
      'st-brown-ha400',
      'st-brown-ha700',
      'st-grey',
      'st-grey-h100',
      'st-grey-h200',
      'st-grey-h300',
      'st-grey-h400',
      'st-grey-h500',
      'st-grey-h600',
      'st-grey-h700',
      'st-grey-h800',
      'st-grey-h900',
      'st-grey-ha100',
      'st-grey-ha200',
      'st-grey-ha400',
      'st-grey-ha700'
    ],
    TERM_IN_YEARS: [
      { value: 0, title: 'Select one' },
      { value: 0, title: 'Not essential' },
      { value: 1, title: '1 year' },
      { value: 2, title: '2 years' },
      { value: 3, title: '3 years' },
      { value: 4, title: '4 years' },
      { value: 5, title: '5 years' },
      { value: 6, title: '6 years' },
      { value: 7, title: '7 years' },
      { value: 8, title: '8 years' },
      { value: 9, title: '9 years' },
      { value: 10, title: '10 years' },
      { value: 11, title: '11 years' },
      { value: 12, title: '12 years' },
      { value: 13, title: '13 years' },
      { value: 14, title: '14 years' },
      { value: 15, title: '15 years' },
      { value: 16, title: '16 years' },
      { value: 17, title: '17 years' },
      { value: 18, title: '18 years' },
      { value: 19, title: '19 years' },
      { value: 20, title: '20 years' },
      { value: 21, title: '21 years' },
      { value: 22, title: '22 years' },
      { value: 23, title: '23 years' },
      { value: 24, title: '24 years' },
      { value: 25, title: '25 years' },
      { value: 26, title: '26 years' },
      { value: 27, title: '27 years' },
      { value: 28, title: '28 years' },
      { value: 29, title: '29 years' },
      { value: 30, title: '30 years' },
      { value: 31, title: '31 years' },
      { value: 32, title: '32 years' },
      { value: 33, title: '33 years' },
      { value: 34, title: '34 years' },
      { value: 35, title: '35 years' },
      { value: 36, title: '36 years' },
      { value: 37, title: '37 years' },
      { value: 38, title: '38 years' },
      { value: 39, title: '39 years' },
      { value: 40, title: '40 years' }
    ],
    TERM_IN_YEARS_SHOWN_IN_MONTHS: [
      { value: 0, title: 'Select one' },
      { value: 0, title: 'Not essential' },
      { value: 0.5, title: '6 months' },
      { value: 1, title: '12 months' },
      { value: 1.5, title: '18 months' },
      { value: 2, title: '24 months' },
      { value: 2.5, title: '30 months' },
      { value: 3, title: '36 months' },
      { value: 3.5, title: '42 months' },
      { value: 4, title: '48 months' },
      { value: 4.5, title: '54 months' },
      { value: 5, title: '60 months' },
      { value: 5.5, title: '66 months' },
      { value: 6, title: '72 months' },
      { value: 6.5, title: '78 months' },
      { value: 7, title: '84 months' },
      { value: 7.5, title: '90 months' },
      { value: 8, title: '96 months' },
      { value: 8.5, title: '102 months' },
      { value: 9, title: '108 months' },
      { value: 9.5, title: '114 months' },
      { value: 10, title: '120 months' },
      { value: 10.5, title: '126 months' },
      { value: 11, title: '132 months' },
      { value: 11.5, title: '138 months' },
      { value: 12, title: '144 months' },
      { value: 12.5, title: '150 months' },
      { value: 13, title: '156 months' },
      { value: 13.5, title: '162 months' },
      { value: 14, title: '168 months' },
      { value: 14.5, title: '174 months' },
      { value: 15, title: '180 months' },
      { value: 15.5, title: '186 months' },
      { value: 16, title: '192 months' },
      { value: 16.5, title: '198 months' },
      { value: 17, title: '204 months' },
      { value: 17.5, title: '210 months' },
      { value: 18, title: '216 months' },
      { value: 18.5, title: '222 months' },
      { value: 19, title: '228 months' },
      { value: 19.5, title: '234 months' },
      { value: 20, title: '240 months' },
      { value: 20.5, title: '246 months' },
      { value: 21, title: '252 months' },
      { value: 21.5, title: '258 months' },
      { value: 22, title: '264 months' },
      { value: 22.5, title: '270 months' },
      { value: 23, title: '276 months' },
      { value: 23.5, title: '282 months' },
      { value: 24, title: '288 months' },
      { value: 24.5, title: '294 months' },
      { value: 25, title: '300 months' },
      { value: 25.5, title: '306 months' },
      { value: 26, title: '312 months' },
      { value: 26.5, title: '318 months' },
      { value: 27, title: '324 months' },
      { value: 27.5, title: '330 months' },
      { value: 28, title: '336 months' },
      { value: 28.5, title: '342 months' },
      { value: 29, title: '348 months' },
      { value: 29.5, title: '354 months' },
      { value: 30, title: '360 months' },
      { value: 30.5, title: '366 months' },
      { value: 31, title: '372 months' },
      { value: 31.5, title: '378 months' },
      { value: 32, title: '384 months' },
      { value: 32.5, title: '390 months' },
      { value: 33, title: '396 months' },
      { value: 33.5, title: '402 months' },
      { value: 34, title: '408 months' },
      { value: 34.5, title: '414 months' },
      { value: 35, title: '420 months' },
      { value: 35.5, title: '426 months' },
      { value: 36, title: '432 months' },
      { value: 36.5, title: '438 months' },
      { value: 37, title: '444 months' },
      { value: 37.5, title: '450 months' },
      { value: 38, title: '456 months' },
      { value: 38.5, title: '462 months' },
      { value: 39, title: '468 months' },
      { value: 39.5, title: '474 months' },
      { value: 40, title: '480 months' }
    ],
    TERM_IN_MONTHS: [
      { value: 0, title: 'Select one', group: '-' },
      { value: 0, title: 'Not essential', group: '-' },
      { value: 12, title: '12 months', group: 'Commonly used' },
      { value: 24, title: '24 months', group: 'Commonly used' },
      { value: 36, title: '36 months', group: 'Commonly used' },
      { value: 48, title: '48 months', group: 'Commonly used' },
      { value: 60, title: '60 months', group: 'Commonly used' },
      { value: 72, title: '72 months', group: 'Commonly used' },
      { value: 84, title: '84 months', group: 'Commonly used' },
      { value: 96, title: '96 months', group: 'Commonly used' },
      { value: 108, title: '108 months', group: 'Commonly used' },
      { value: 120, title: '120 months', group: 'Commonly used' },
      { value: 132, title: '132 months', group: 'Commonly used' },
      { value: 144, title: '144 months', group: 'Commonly used' },
      { value: 156, title: '156 months', group: 'Commonly used' },
      { value: 160, title: '160 months', group: 'Commonly used' },
      { value: 180, title: '180 months', group: 'Commonly used' },
      { value: 1, title: '1 month', group: 'Other' },
      { value: 2, title: '2 months', group: 'Other' },
      { value: 3, title: '3 months', group: 'Other' },
      { value: 4, title: '4 months', group: 'Other' },
      { value: 5, title: '5 months', group: 'Other' },
      { value: 6, title: '6 months', group: 'Other' },
      { value: 7, title: '7 months', group: 'Other' },
      { value: 8, title: '8 months', group: 'Other' },
      { value: 9, title: '9 months', group: 'Other' },
      { value: 10, title: '10 months', group: 'Other' },
      { value: 11, title: '11 months', group: 'Other' },
      { value: 13, title: '13 months', group: 'Other' },
      { value: 14, title: '14 months', group: 'Other' },
      { value: 15, title: '15 months', group: 'Other' },
      { value: 16, title: '16 months', group: 'Other' },
      { value: 17, title: '17 months', group: 'Other' },
      { value: 18, title: '18 months', group: 'Other' },
      { value: 19, title: '19 months', group: 'Other' },
      { value: 20, title: '20 months', group: 'Other' },
      { value: 21, title: '21 months', group: 'Other' },
      { value: 22, title: '22 months', group: 'Other' },
      { value: 23, title: '23 months', group: 'Other' },
      { value: 25, title: '25 months', group: 'Other' },
      { value: 26, title: '26 months', group: 'Other' },
      { value: 27, title: '27 months', group: 'Other' },
      { value: 28, title: '28 months', group: 'Other' },
      { value: 29, title: '29 months', group: 'Other' },
      { value: 30, title: '30 months', group: 'Other' },
      { value: 31, title: '31 months', group: 'Other' },
      { value: 32, title: '32 months', group: 'Other' },
      { value: 33, title: '33 months', group: 'Other' },
      { value: 34, title: '34 months', group: 'Other' },
      { value: 35, title: '35 months', group: 'Other' },
      { value: 37, title: '37 months', group: 'Other' },
      { value: 38, title: '38 months', group: 'Other' },
      { value: 39, title: '39 months', group: 'Other' },
      { value: 40, title: '40 months', group: 'Other' },
      { value: 41, title: '41 months', group: 'Other' },
      { value: 42, title: '42 months', group: 'Other' },
      { value: 43, title: '43 months', group: 'Other' },
      { value: 44, title: '44 months', group: 'Other' },
      { value: 45, title: '45 months', group: 'Other' },
      { value: 46, title: '46 months', group: 'Other' },
      { value: 47, title: '47 months', group: 'Other' },
      { value: 49, title: '49 months', group: 'Other' },
      { value: 50, title: '50 months', group: 'Other' },
      { value: 51, title: '51 months', group: 'Other' },
      { value: 52, title: '52 months', group: 'Other' },
      { value: 53, title: '53 months', group: 'Other' },
      { value: 54, title: '54 months', group: 'Other' },
      { value: 55, title: '55 months', group: 'Other' },
      { value: 56, title: '56 months', group: 'Other' },
      { value: 57, title: '57 months', group: 'Other' },
      { value: 58, title: '58 months', group: 'Other' },
      { value: 59, title: '59 months', group: 'Other' },
      { value: 61, title: '61 months', group: 'Other' },
      { value: 62, title: '62 months', group: 'Other' },
      { value: 63, title: '63 months', group: 'Other' },
      { value: 64, title: '64 months', group: 'Other' },
      { value: 65, title: '65 months', group: 'Other' },
      { value: 66, title: '66 months', group: 'Other' },
      { value: 67, title: '67 months', group: 'Other' },
      { value: 68, title: '68 months', group: 'Other' },
      { value: 69, title: '69 months', group: 'Other' },
      { value: 70, title: '70 months', group: 'Other' },
      { value: 71, title: '71 months', group: 'Other' },
      { value: 72, title: '72 months', group: 'Other' },
      { value: 73, title: '73 months', group: 'Other' },
      { value: 74, title: '74 months', group: 'Other' },
      { value: 75, title: '75 months', group: 'Other' },
      { value: 76, title: '76 months', group: 'Other' },
      { value: 77, title: '77 months', group: 'Other' },
      { value: 78, title: '78 months', group: 'Other' },
      { value: 79, title: '79 months', group: 'Other' },
      { value: 80, title: '80 months', group: 'Other' },
      { value: 81, title: '81 months', group: 'Other' },
      { value: 82, title: '82 months', group: 'Other' },
      { value: 83, title: '83 months', group: 'Other' },
      { value: 85, title: '85 months', group: 'Other' },
      { value: 86, title: '86 months', group: 'Other' },
      { value: 87, title: '87 months', group: 'Other' },
      { value: 88, title: '88 months', group: 'Other' },
      { value: 89, title: '89 months', group: 'Other' },
      { value: 90, title: '90 months', group: 'Other' },
      { value: 91, title: '91 months', group: 'Other' },
      { value: 92, title: '92 months', group: 'Other' },
      { value: 93, title: '93 months', group: 'Other' },
      { value: 94, title: '94 months', group: 'Other' },
      { value: 95, title: '95 months', group: 'Other' },
      { value: 97, title: '97 months', group: 'Other' },
      { value: 98, title: '98 months', group: 'Other' },
      { value: 99, title: '99 months', group: 'Other' },
      { value: 100, title: '100 months', group: 'Other' },
      { value: 101, title: '101 months', group: 'Other' },
      { value: 102, title: '102 months', group: 'Other' },
      { value: 103, title: '103 months', group: 'Other' },
      { value: 104, title: '104 months', group: 'Other' },
      { value: 105, title: '105 months', group: 'Other' },
      { value: 106, title: '106 months', group: 'Other' },
      { value: 107, title: '107 months', group: 'Other' },
      { value: 109, title: '109 months', group: 'Other' },
      { value: 110, title: '110 months', group: 'Other' },
      { value: 111, title: '111 months', group: 'Other' },
      { value: 112, title: '112 months', group: 'Other' },
      { value: 113, title: '113 months', group: 'Other' },
      { value: 114, title: '114 months', group: 'Other' },
      { value: 115, title: '115 months', group: 'Other' },
      { value: 116, title: '116 months', group: 'Other' },
      { value: 117, title: '117 months', group: 'Other' },
      { value: 118, title: '118 months', group: 'Other' },
      { value: 119, title: '119 months', group: 'Other' },
      { value: 121, title: '121 months', group: 'Other' },
      { value: 122, title: '122 months', group: 'Other' },
      { value: 123, title: '123 months', group: 'Other' },
      { value: 124, title: '124 months', group: 'Other' },
      { value: 125, title: '125 months', group: 'Other' },
      { value: 126, title: '126 months', group: 'Other' },
      { value: 127, title: '127 months', group: 'Other' },
      { value: 128, title: '128 months', group: 'Other' },
      { value: 129, title: '129 months', group: 'Other' },
      { value: 130, title: '130 months', group: 'Other' },
      { value: 131, title: '131 months', group: 'Other' },
      { value: 133, title: '133 months', group: 'Other' },
      { value: 134, title: '134 months', group: 'Other' },
      { value: 135, title: '135 months', group: 'Other' },
      { value: 136, title: '136 months', group: 'Other' },
      { value: 137, title: '137 months', group: 'Other' },
      { value: 138, title: '138 months', group: 'Other' },
      { value: 139, title: '139 months', group: 'Other' },
      { value: 140, title: '140 months', group: 'Other' },
      { value: 141, title: '141 months', group: 'Other' },
      { value: 142, title: '142 months', group: 'Other' },
      { value: 143, title: '143 months', group: 'Other' },
      { value: 145, title: '145 months', group: 'Other' },
      { value: 146, title: '146 months', group: 'Other' },
      { value: 147, title: '147 months', group: 'Other' },
      { value: 148, title: '148 months', group: 'Other' },
      { value: 149, title: '149 months', group: 'Other' },
      { value: 150, title: '150 months', group: 'Other' },
      { value: 151, title: '151 months', group: 'Other' },
      { value: 152, title: '152 months', group: 'Other' },
      { value: 153, title: '153 months', group: 'Other' },
      { value: 154, title: '154 months', group: 'Other' },
      { value: 155, title: '155 months', group: 'Other' },
      { value: 157, title: '157 months', group: 'Other' },
      { value: 158, title: '158 months', group: 'Other' },
      { value: 159, title: '159 months', group: 'Other' },
      { value: 160, title: '160 months', group: 'Other' },
      { value: 161, title: '161 months', group: 'Other' },
      { value: 162, title: '162 months', group: 'Other' },
      { value: 163, title: '163 months', group: 'Other' },
      { value: 164, title: '164 months', group: 'Other' },
      { value: 165, title: '165 months', group: 'Other' },
      { value: 166, title: '166 months', group: 'Other' },
      { value: 167, title: '167 months', group: 'Other' },
      { value: 169, title: '169 months', group: 'Other' },
      { value: 170, title: '170 months', group: 'Other' },
      { value: 171, title: '171 months', group: 'Other' },
      { value: 172, title: '172 months', group: 'Other' },
      { value: 173, title: '173 months', group: 'Other' },
      { value: 174, title: '174 months', group: 'Other' },
      { value: 175, title: '175 months', group: 'Other' },
      { value: 176, title: '176 months', group: 'Other' },
      { value: 177, title: '177 months', group: 'Other' },
      { value: 178, title: '178 months', group: 'Other' },
      { value: 179, title: '179 months', group: 'Other' }
    ],
    TERM_IN_MONTHS_SHOWN_IN_YEARS: [
      { value: 0, title: 'Select one' },
      { value: 0, title: 'Not Essential' },
      { value: 12, title: '1 year' },
      { value: 24, title: '2 years' },
      { value: 36, title: '3 years' },
      { value: 48, title: '4 years' },
      { value: 60, title: '5 years' },
      { value: 72, title: '6 years' },
      { value: 84, title: '7 years' },
      { value: 96, title: '8 years' },
      { value: 108, title: '9 years' },
      { value: 120, title: '10 years' },
      { value: 132, title: '11 years' },
      { value: 144, title: '12 years' },
      { value: 156, title: '13 years' },
      { value: 168, title: '14 years' },
      { value: 180, title: '15 years' },
      { value: 192, title: '16 years' },
      { value: 204, title: '17 years' },
      { value: 216, title: '18 years' },
      { value: 228, title: '19 years' },
      { value: 240, title: '20 years' },
      { value: 252, title: '21 years' },
      { value: 264, title: '22 years' },
      { value: 276, title: '23 years' },
      { value: 288, title: '24 years' },
      { value: 300, title: '25 years' },
      { value: 312, title: '26 years' },
      { value: 324, title: '27 years' },
      { value: 336, title: '28 years' },
      { value: 348, title: '29 years' },
      { value: 360, title: '30 years' },
      { value: 372, title: '31 years' },
      { value: 384, title: '32 years' },
      { value: 396, title: '33 years' },
      { value: 408, title: '34 years' },
      { value: 420, title: '35 years' },
      { value: 332, title: '36 years' },
      { value: 344, title: '37 years' },
      { value: 356, title: '38 years' },
      { value: 368, title: '39 years' },
      { value: 380, title: '40 years' }
    ]
  });
